<template>
  <div class="top-navigator">
    <div class="top-navigator-left">
      <img class="logo" :src="require('@/assets/zsplus.png')" />
      <div class="line"></div>
      <div class="channel" v-if="categoryList && categoryList.length > 0">
        {{ categoryList[0].name + "频道" }}
      </div>
    </div>
    <wx-open-launch-app
      class="top-navigator-right"
      id="launch-btn"
      appid="wxc9da92efaf026389"
      :extinfo="
        categoryList.length > 0
          ? 'category_id=' + categoryList[0].redirectCategoryId
          : ''
      "
      @launch="handleLaunch"
      @error="handleError"
    >
      <div v-is="'script'" type="text/wxtag-template">
        <button
          style="
            border-width: 0px;
            height: 25px;
            width: 100%;
            border-radius: 12.5px;
            color: red;
            font-size: 12px;
            font-weight: 700;
            background-color: white;
            line-height: 25px;
            white-space: nowrap;
          "
          class="btn"
        >
          打开APP
        </button>
      </div>
    </wx-open-launch-app>
  </div>
  <div class="tab">
    <van-tabs
      :shrink="true"
      :sticky="true"
      :ellipsis="false"
      :before-change="beforeChange"
      line-width="8vw"
      line-height="0.6vw"
      offset-top="10vw"
    >
      <van-tab v-for="(category, index) in categoryList" :key="index">
        <template #title>
          <div class="tab-title">
            {{ index == 0 ? "首页" : category.name }}
            <div
              class="toMiniProgram"
              v-if="
                category.redirectType == 2 &&
                category.originalId !== '' &&
                category.path !== ''
              "
            >
              <wx-open-launch-weapp
                v-if="isWechat"
                id="launch-btn"
                :username="category.originalId"
                :path="category.path"
                style=""
                @launch="handleLaunch"
                @error="handleError"
              >
                <div v-is="'script'" type="text/wxtag-template">
                  <button
                    style="
                      border-width: 0;
                      width: 112px;
                      height: 34px;
                      background: rgba(0, 0, 0, 0);
                    "
                  ></button>
                </div>
              </wx-open-launch-weapp>
            </div>
          </div>
        </template>
        <NewsList
          class="content"
          :category="category"
          v-if="category.redirectCategoryId"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import NewsList from "../components/NewsList.vue";
import { Tab, Tabs, Sticky } from "vant";
export default {
  name: "Home",
  components: {
    NewsList,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Sticky.name]: Sticky,
  },
  setup() {
    const store = useStore();
    const userAgentString = navigator.userAgent.toLowerCase();
    onMounted(() => {
      store.dispatch("getCategory").then(() => {});
    });

    const beforeChange = (index) => {
      if (index >= store.state.categoryList.length) {
        return false;
      }
      // 返回 false 表示阻止此次切换
      if (store.state.categoryList[index].redirectType == 3) {
        return true;
      } else if (store.state.categoryList[index].redirectType == 1) {
        window.open(store.state.categoryList[index].url, "_blank");
        return false;
      } else if (store.state.categoryList[index].redirectType == 2) {
        return false;
      } else {
        return true;
      }
    };

    const handleLaunch = (e) => {
      console.log(e);
    };

    const handleError = (e) => {
      console.log(e.detail);
      window.open(
        "https://www.zsnews.cn/app/mobile.html?platform=mobile",
        "_blank"
      );
    };

    return {
      handleError,
      handleLaunch,
      beforeChange,
      categoryList: computed(() => store.state.categoryList),
      loading: computed(() => {
        return store.state.newsList > 0;
      }),
      isWechat: userAgentString.indexOf("micromessenger") >= 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.tab {
  // --van-tabs-nav-background-color: rgb(277, 19, 19);
  position: absolute;
  top: 10vw;
  left: 0;
  width: 100vw;
  --van-tab-font-size: 4.53vw;
  --van-tabs-line-height: 10vw;
  .tab-header {
    width: 100vw;
  }
}
.top-navigator {
  z-index: 100;
  position: fixed;
  width: 100%;
  // height: 50px;
  height: 10vw;
  background-color: rgb(277, 19, 19);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-navigator-right {
    width: 18vw;
    margin-right: 2vw;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .top-navigator-left {
    height: 100%;
    display: flex;
    align-items: center;
    .logo {
      margin-left: 20px;
      height: 80%;
      width: auto;
    }
    .line {
      margin-left: 12px;
      height: 50%;
      width: 1px;
      background-color: white;
    }
    .channel {
      margin-left: 12px;
      color: white;
      font-size: 4.53vw;
      font-weight: 800;
      white-space: nowrap;
    }
  }
}
.tab-title {
  position: relative;
  .toMiniProgram {
    position: absolute;
    left: 0;
    top: -10px;
    z-index: 100;
    width: 100%;
    height: 40px;
  }
}
</style>
